import { toast } from "sonner";
import { fmtBRL, fmtDate } from "@/lib/api";

export const m3uUrl = (c) =>
  `http://weepo.ca/get.php?username=${encodeURIComponent(c.panel_user || "")}&password=${encodeURIComponent(c.panel_password || "")}&type=m3u_plus&output=mpegts`;

export const pixOk = (c) => !!(c.invoice_link && c.external_id && c.invoice_link.replace(/\/$/, "").endsWith(`/${c.external_id}`));

export const clientInfoText = (c) => [
  "*Seguem seus dados de acesso:*",
  `✅ *Nome:* ${c.name || "—"}`,
  `✅ *Usuário:* ${c.panel_user || "—"}`,
  `✅ *Senha:* ${c.panel_password || "—"}`,
  `📦 *Plano:* ${c.plan || "—"}`,
  `💳 *Assinar/Renovar Plano:* ${pixOk(c) ? c.invoice_link : "—"}`,
  `💵 *Preço do Plano:* ${c.value ? fmtBRL(c.value) : "—"}`,
  `🗓️ *Vencimento:* ${c.due_date ? fmtDate(c.due_date) : "—"}`,
  `📶 *Conexões:* ${c.connections ?? "—"}`,
].join("\n");

export const copyInfo = (c) => {
  navigator.clipboard.writeText(clientInfoText(c));
  toast.success(pixOk(c) ? "Informações copiadas" : "Informações copiadas (sem link PIX válido — sincronize o cliente)");
};

export const copyM3U = (c) => {
  navigator.clipboard.writeText(m3uUrl(c));
  toast.success("Lista M3U copiada");
};

export const ssiptvUrl = (c) => `http://e.anax3.ca/p/${c.panel_user}/${c.panel_password}/ssiptv`;

export const copySSIPTV = (c) => {
  navigator.clipboard.writeText(ssiptvUrl(c));
  toast.success("URL do SS IPTV copiada");
};

export const copyPix = (c) => {
  navigator.clipboard.writeText(c.invoice_link);
  toast.success("Link PIX copiado");
};
